import { RiLock2Line } from "react-icons/ri";

const Forbidden = ({loading}) => {
    if(loading)
        return(<div align="center" style={{ width:"100%" }}>
            <br/><br/>
            <RiLock2Line style={{ fontSize:"5em", color:"var(--corpay-maroon-light)" }} /><br/><br/>
            <header style={{ fontSize:'1.5em' }}>Checking User Permissions...</header>
        </div>)
    else
        return (<div align="center" style={{ width:"100%" }}>
            <br/><br/>
            <RiLock2Line style={{ fontSize:"5em", color:"var(--corpay-maroon-light)" }} /><br/><br/>
            <div style={{ lineHeight: '28px', fontSize:'16px' }}>
                <header style={{ color: '#f38800', fontSize:'1.5em' }}>You Do Not Have Access To That Page</header>
                Please contact your acccount administrator.<br/><br/>
                If you believe this to be an error,<br/> 
                please contact us at <a href="mailto:info@ias.corpay.com">info@ias.corpay.com</a>
            </div>
        </div>)
}

export default Forbidden